// Note -- Pulling in constants from common/usermanagement

export const RETURNING_USER = 'RETURNING_USER';


// WEBPACK FOOTER //
// ./src/routes/Profile/modules/constants.js